import React, { useState } from 'react'
import Style from './Navabar.module.css'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';



const Navabar = () => {

    const [menubtn, setMenubtn] = useState(false);
    const openHandler = () => {
        setMenubtn(!menubtn);
    }

    
  const gotoBtnTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" })
  }
    return (
        <>

            {/* <div className={ Style.main }>
                {/* contact nymber */ }
            <div>
                <Row className={ Style.contact1 }>
                    <Col xs={ 10 } lg={ 9 } sm={ 12 }>
                        <div>
                            <h5 className={ Style.contact }>
                                <span>
                                    <i class="fa-solid fa-phone"><a href="tel:+91 9979696381">+91 99796 96381</a></i> &nbsp;
                                    <i class="fa-solid fa-phone"><a href="tel:+91 9879468031">+91 98794 68031</a></i>
                                </span>
                            </h5>
                        </div>
                    </Col>

                    <Col xs={ 12 } lg={ 3 } sm={ 12 }>
                        <div>

                            <a className={ Style.email } href="mailto:dholariyaunit@gmail.com">
                                <i className="fa-solid fa-envelope m-1">
                                </i>
                                <span >dholariyaunit@gmail.com</span>
                            </a>

                        </div>
                    </Col>
                </Row>
            </div>

           
                <div className={ Style.mainnav }>
                    {/* <Container> */}
                        <div className={ Style.navbar }>
                            <div className={ Style.logo }>
                                <Link to={ '/' }>
                                    {/* <h2>Khodal Jari</h2> */ }

                                    <h5 className={ Style.logoname }>Khodal Jari</h5>
                                </Link>

                            </div>
                            <div className={ Style.menubtn }>
                                {
                                    menubtn ?
                                        <i className="fa-solid fa-xmark" onClick={ openHandler }></i>
                                        :
                                        <i className="fa-solid fa-bars" onClick={ openHandler }></i>
                                }
                            </div>
                            <div className={ Style.menu }>
                                <ul>
                                    <li className={ Style.focus }>
                                        <Link onClick={gotoBtnTop} className={ Style.focus } to={ '/' }>
                                            Home
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={gotoBtnTop} className={ Style.focus } to={ '/aboutme' } >
                                            Aboutme
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={gotoBtnTop} className={ Style.focus } to={ '/product' }>
                                            Product
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={gotoBtnTop} className={ Style.focus } to={ '/team' }>
                                            Team
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={gotoBtnTop} className={ Style.focus } to={ '/inf' }>
                                            Infrastructure
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={gotoBtnTop} className={ Style.focus } to={ '/contact' }>
                                            Contact

                                        </Link>
                                    </li>

                                </ul>

                            </div>

                            <div>
                                <div className={ Style.logo2 }>

                                    <Link className='d-flex' to={ '/' }>

                                        <h5 className={ Style.logoname }>EXPORT QULITY</h5>
                                    </Link>

                                </div>

                            </div>
                        </div>
                    {/* </Container> */}

                    {
                        menubtn ?
                            <div className={ Style.sidebar }>
                                <div className={ Style.menus }>
                                    <ul>
                                        <li onClick={ openHandler }>
                                            <Link onClick={gotoBtnTop} to={ '/' } >
                                                Home
                                            </Link>
                                        </li>
                                        <li onClick={ openHandler }>
                                            <Link onClick={gotoBtnTop} to={ '/aboutme' } >
                                                Aboutme
                                            </Link>
                                        </li>
                                        <li onClick={ openHandler }>
                                            <Link onClick={gotoBtnTop} to={ '/product' }>
                                                Product
                                            </Link>
                                        </li>
                                        <li onClick={ openHandler }>
                                            <Link onClick={gotoBtnTop} to={ '/team' }>
                                                Team
                                            </Link>
                                        </li>
                                        <li onClick={ openHandler }>
                                            <Link onClick={gotoBtnTop} to={ '/inf' }>
                                                Infrastructure
                                            </Link>
                                        </li>
                                        <li onClick={ openHandler }>
                                            <Link onClick={gotoBtnTop} to={ '/contact' }>
                                                Contact
                                            </Link>
                                        </li>

                                        {/* <li onClick={ openHandler }>
                                            <Link to={ '/custmur' }>
                                                Custumer
                                            </Link>
                                        </li> */}

                                    </ul>
                                </div>

                                <div className={ Style.logo }>
                                    <Link to={ '/' }>


                                        <h5 className={ Style.logoname }>EXPORT QULITY</h5>
                                    </Link>

                                </div>
                            </div>
                            : null
                    }

                </div>
            
        </>
    )
}

export default Navabar
